<template>
  <page-edicion>
    <page-header :title="divisa.nombre" subtitle="Tasas de cambio" @back="volver()" />
    <h3>Nueva tasa</h3>
    <b-form @submit.prevent="agregarTasa">
      <b-row class="align-items-baseline">
        <b-col>
          <b-form-group label="Fecha de inicio">
            <b-form-datepicker v-model="nuevaTasa.fechaInicio" required />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Fecha de fin">
            <b-form-datepicker v-model="nuevaTasa.fechaFin" required />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Tasa de cambio">
            <b-form-input
              type="number"
              v-model="nuevaTasa.tasaConversion"
              :placeholder="`1,00€ es igual a X ${divisa.abreviatura}`"
              min="0.0001"
              max="9999999.9999"
              step="0.0001"
              required
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-button type="submit" variant="success" size="sm">Agregar tasa</b-button>
        </b-col>
      </b-row>
    </b-form>

    <h3>Tasas de cambio para {{ divisa.nombre }}</h3>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th width="30%">Fecha inicio</th>
          <th width="30%">Fecha fin</th>
          <th width="20%">Tasa de cambio</th>
          <th width="20%">-</th>
        </tr>
      </thead>
      <tbody>
        <row-tasa v-for="tasa in tasas" :key="tasa.id" :tasa="tasa" />
      </tbody>
    </table>
  </page-edicion>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useDivisaStore } from "@/stores/DivisaStore";
import RowTasa from "@/views/divisas/RowTasa.vue";

export default {
  components: { RowTasa },
  computed: mapState(useDivisaStore, ["divisa", "tasas"]),
  data() {
    return {
      nuevaTasa: {},
    };
  },
  methods: {
    ...mapActions(useDivisaStore, ["guardarTasa"]),
    async agregarTasa() {
      await this.guardarTasa(this.nuevaTasa);
      this.$messages.success("Tasa guardada");
      this.nuevaTasa = {};
    },
    volver() {
      if (this.$route.query.from == "editar") {
        this.$router.push("/divisas/editar/" + this.divisa.id);
      } else {
        this.$router.push("/divisas");
      }
    },
  },
  watch: {
    "$route.params": {
      handler: function () {
        const store = useDivisaStore();
        const id = this.$route.params.id;
        store.cargar(id);
        store.cargarTasas(id);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
